import { useState } from "react";
import { useCart, useCartTotal } from "../state/cart";
import { useOrder } from "../state/order";
import { buildOrderPayload, sendOrder } from "../api/order";
import toast from "react-hot-toast";
import { repriceCartItems } from "../api/pricing";

export default function CheckoutButton() {
  const items = useCart((s) => s.items);
  const clear = useCart((s) => s.clear);
  const replacePrices = useCart((s) => s.replacePrices);
  const total = useCartTotal();
  const table = useOrder((s) => s.table);
  const persons = useOrder((s) => s.persons || 1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const canSubmit = items.length > 0 && typeof table === "number" && table > 0;

  const handleCheckout = async () => {
    setError(null);
    if (!canSubmit) {
      if (!items.length) setError("Корзина пуста");
      else if (!table) setError("Выберите номер стола");
      else if (!persons) setError("Укажите количество персон");
      return;
    }

    try {
      setLoading(true);

      const { latestById, changed } = await repriceCartItems(items);
      if (changed.length > 0) {
        replacePrices(latestById);
        toast.error("Цены изменились. Корзина обновлена, оформите заново.");
        return;
      }

      const payload = buildOrderPayload(table!, persons!, items);

      await sendOrder(payload);

      setDone(true);
      clear();
      toast.success("Заказ оформлен!");
    } catch (e: any) {
      console.error(e);
      setError("Не удалось оформить заказ. Повторите попытку.");
      toast.error("Ошибка отправки заказа");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="w-full h-11 rounded bg-emerald-500/10 border border-emerald-500 text-emerald-700 text-sm grid place-items-center">
        Заказ оформлен! Спасибо 🙌
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {error && <div className="text-xs text-red-600">{error}</div>}
      <button
        disabled={!canSubmit || loading}
        onClick={handleCheckout}
        className={`w-full h-11 rounded text-white text-sm font-semibold text-center whitespace-nowrap active:scale-[.99]
    ${!canSubmit || loading ? "bg-gray-300 cursor-not-allowed" : "bg-[#FFB701]"}
  `}
      >
        {loading ? "Оформляем..." : "Оформить заказ"}
      </button>
    </div>
  );
}
